import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Map/FilterModal/index.js",
  _this = this;
import React, { useEffect, useState } from 'react';
import Modal from '../../Modal';
import Checkbox from '../../Checkbox';
import Button from '../../Button';
import Spacing from '../../Spacing';
var FilterModal = function FilterModal(_ref) {
  var filters = _ref.filters,
    title = _ref.title,
    buttonLabel = _ref.buttonLabel,
    onFilterModalClose = _ref.onFilterModalClose,
    onFiltersUpdated = _ref.onFiltersUpdated;
  var _useState = useState(filters),
    _useState2 = _slicedToArray(_useState, 2),
    filterOptions = _useState2[0],
    setFilterOptions = _useState2[1];
  useEffect(function () {
    setFilterOptions(filters);
  }, [filters]);
  var onModalClose = function onModalClose() {
    onFilterModalClose();
  };
  var onFilterOptionClick = function onFilterOptionClick(filterOption, selected) {
    var updatedFilterOptions = filterOptions.map(function (opt) {
      if (opt.value === filterOption.value) {
        return Object.assign({}, opt, {
          selected: selected
        });
      }
      return opt;
    });
    setFilterOptions(updatedFilterOptions);
  };
  var onApplyButtonClick = function onApplyButtonClick() {
    var selectedFilters = filterOptions.filter(function (opt) {
      return opt.selected;
    }).map(function (opt) {
      return opt.value;
    });
    if (selectedFilters.length > 0) {
      onFiltersUpdated(filterOptions);
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    visible: true,
    title: title,
    onClose: onModalClose,
    "data-testid": "filter-modal",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Modal.Content, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 7
    }
  }, filterOptions.map(function (filterOption) {
    return /*#__PURE__*/React.createElement(Spacing, {
      bottom: 2,
      key: filterOption.value,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Checkbox.Input, {
      label: filterOption.name,
      onChange: function onChange(e, selected) {
        onFilterOptionClick(filterOption, selected);
      },
      checked: filterOption.selected,
      "data-testid": "checkbox-".concat(filterOption.value),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 15
      }
    }));
  }), /*#__PURE__*/React.createElement(Spacing, {
    top: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    onClick: onApplyButtonClick,
    "data-testid": "filter-modal-button",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 11
    }
  }, buttonLabel))));
};
export default FilterModal;